import Card, { CardContent } from '@/components/card';
import SimpleTabs from '@/components/simple-tabs';
import { styled, Table, TableCell } from '@mui/material';

import { FC } from 'react';

import { ActivitySummary } from './ActivitySummary/ActivitySummary.component';
import { BalanceBreakdownBySource } from './BalanceBreakdownBySource.component';

export const PrimaryTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.grey100.main,
  fontSize: theme.typography.body1.fontSize
}));

export const SecondaryTableCell = styled(TableCell)(({ theme }) => ({
  paddingLeft: theme.spacing(6)
}));

export const LastTableRowNoBorderTable = styled(Table)(() => ({
  '& tbody tr:last-child td': {
    border: 'none'
  }
}));

export const BalancesTable: FC<{
  participantId: number;
}> = props => {
  return (
    <Card data-testid='participant-balances-card'>
      <SimpleTabs
        tabs={[
          {
            component: (
              <CardContent>
                <ActivitySummary employeeId={props.participantId} />
              </CardContent>
            ),
            label: 'Activity Summary'
          },
          {
            component: (
              <CardContent>
                <BalanceBreakdownBySource participantId={props.participantId} />
              </CardContent>
            ),
            label: 'Balance Breakdown by Source'
          }
        ]}
        tabsAriaLabel='balances-table-tabs'
      />
    </Card>
  );
};
